import { isImportedPolicy } from 'core/helpers/policy-status';

/**
 * Where the "Information from Prior Carrier" card's values came from (#36821).
 *
 * On a policy migrated from a legacy carrier system the importer fills the prior-carrier fields from
 * the legacy record (GO's BasicPolicy), not from a Coverage Verifier pull: the card says so, and the
 * proof-of-prior callout stays quiet because no such task exists for a migrated term (#36138) or for
 * the renewal of one with complete migrated data (#36821).
 */

/** The migrated lineage: the imported term itself, or any renewal descended from it. */
export const isMigratedLineage = (policy) =>
  !!policy && (isImportedPolicy(policy) || !!policy.wasRenewedFromImportedTerm);

/** The source label to show beside the card title, or null when the values are live CV data. */
export const priorCoverageSourceLabel = ({ policy, global }) => {
  if (!isMigratedLineage(policy) || global?.receivedCVData) {
    return null;
  }
  const source = policy?.importedData?.conversionMetadata?.source;
  return `Source: ${source === 'guidewire' ? 'GO migration' : 'migrated policy data'}`;
};

/** The transfer-discount inputs GO rated on; only a migrated CFM auto carries them. */
export const priorCoverageDiscountRows = (auto) => {
  const rows = [];
  if (auto?.priorCoverageMonthsInForce != null) {
    rows.push({
      name: 'priorCoverageMonthsInForce',
      label: 'Months in Force',
      value: String(auto.priorCoverageMonthsInForce)
    });
  }
  if (auto?.priorCoverageLapseDays != null) {
    rows.push({ name: 'priorCoverageLapseDays', label: 'Lapse Days', value: String(auto.priorCoverageLapseDays) });
  }
  return rows;
};
